"use client"

import { useEffect, useState } from "react"
import { cn } from "../../lib/utils"

interface SportsLoadingProps {
  className?: string
  message?: string
  progress?: number
}

export function SportsLoading({
  className,
  message = "Preparando seu estúdio de customização...",
  progress,
}: SportsLoadingProps) {
  const [dots, setDots] = useState("")

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."))
    }, 500)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className={cn("fixed inset-0 z-50 flex items-center justify-center bg-background", className)}>
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 35px,
            currentColor 35px,
            currentColor 36px
          )`,
          }}
        />
      </div>

      <div className="relative z-10 flex flex-col items-center gap-8 px-4">
        {/* Main Loading Animation */}
        <div className="relative">
          {/* Pulse Rings */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div
              className="absolute h-32 w-32 rounded-full border-4 border-primary/30"
              style={{
                animation: "pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
              }}
            />
            <div
              className="absolute h-32 w-32 rounded-full border-4 border-accent/30"
              style={{
                animation: "pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite 1s",
              }}
            />
          </div>

          {/* Jersey Icon with Animation */}
          <div className="relative h-32 w-32 overflow-hidden rounded-full bg-card shadow-2xl">
            <div className="absolute inset-0 flex items-center justify-center">
              {/**<svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="h-16 w-16 text-primary"
                style={{
                  animation: "rotate-slow 8s linear infinite",
                }}
              >
                <path
                  d="M12 2L4 6v4c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-8-4z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="M12 8v8M8 12h8" strokeLinecap="round" strokeLinejoin="round" />
              </svg> */}
              <img id="logo-client-loading" className="!max-w-[65%] drop-shadow-xs"></img>
            </div>

            {/* Sliding Jersey Effect */}
            <div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-accent/20 to-transparent"
              style={{
                animation: "jersey-slide 3s ease-in-out infinite",
              }}
            />
          </div>

          {/* Rotating Border */}
          <svg
            className="absolute inset-0 h-32 w-32"
            style={{
              animation: "rotate-slow 4s linear infinite reverse",
            }}
          >
            <circle
              cx="64"
              cy="64"
              r="60"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeDasharray="20 10"
              className="text-primary"
              opacity="0.3"
            />
          </svg>
        </div>

        {/* Loading Text */}
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-2xl font-bold tracking-tight text-foreground">Carregando{dots}</h2>
          <p className="max-w-md text-center text-sm text-muted-foreground leading-relaxed">{message}</p>
        </div>

        {/* Progress Bar */}
       {/** {progress !== undefined && (
          <div className="w-full max-w-xs">
            <div className="h-2 overflow-hidden rounded-full bg-secondary">
              <div
                className="h-full bg-primary transition-all duration-500 ease-out"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="mt-2 text-center text-xs text-muted-foreground">{progress}%</p>
          </div>
        )} */}

        {/* Feature Icons 
        <div className="flex items-center gap-6 opacity-40">
          {[
            { icon: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5", label: "3D" },
            {
              icon: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
              label: "Design",
            },
            { icon: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", label: "Orçamento" },
          ].map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-2 w-[70px]"
              style={{
                animation: `fade-in 0.5s ease-out ${i * 0.2}s both`,
              }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
                <path d={item.icon} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="text-xs font-medium">{item.label}</span>
            </div>
          ))}
        </div>*/}
      </div>
    </div>
  )
}